class MHeader extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        headers: ["header"],
        logos: [".m-logo"],
        topbar: ".m-topbar",
        headerWrapper: ".m-header__wrapper",
        topbarClose: ".m-topbar__close",
      }),
      (this.domNodes = queryDomNodes(this.selectors, this)),
      (this.innerWidth = window.innerWidth),
      (this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop),
      (this.headerHeight = this.domNodes.headerWrapper.offsetHeight),
      (this.stickyEnabled = "true" === this.dataset.sticky || !1),
      (this.classes = {
        scrollUp: "scroll-up",
        scrollDown: "scroll-down",
        stuck: "stuck",
      }),
      this.init();
  }
  init() {
    (this.transparentHeader =
      this.domNodes &&
      this.domNodes.headers[0] &&
      "true" === this.domNodes.headers[0].dataset.transparent),
      this.initAddon(),
      this.handleSticky(),
      document.addEventListener("matchMobile", () => this.handleSticky()),
      document.addEventListener("unmatchMobile", () => this.handleSticky()),
      (this.siteNav = new SiteNav(this)),
      (window.__sfHeader = this),
      window.addEventListener("resize", () => {
        this.innerWidth = window.innerWidth;
      }),
      this.transparentHeader && this.innerWidth > 1280
        ? this.domNodes.headerWrapper &&
          this.domNodes.headerWrapper.classList.add("transparent-on-top")
        : this.domNodes.headerWrapper &&
          this.domNodes.headerWrapper.classList.remove("transparent-on-top");
  }
  initAddon() {
    (this.megamenu = new Megamenu(this)),
      Shopify.designMode &&
        ((MinimogTheme = MinimogTheme || {}),
        MinimogTheme &&
          MinimogTheme.Wishlist &&
          MinimogTheme.Wishlist.updateWishlistCount());
  }
  handleSticky() {
    let s = 20;
    document
      .querySelectorAll(".shopify-section-group-header-group")
      .forEach((e) => {
        e.classList.contains("m-section-header") || (s += e.offsetHeight);
      });
    const e = document.querySelector(".m-topbar");
    if ((e && (s += e.offsetHeight), !this.stickyEnabled)) return;
    let t = 0;
    window.addEventListener("scroll", () => {
      const e = window.scrollY;
      if (e <= s)
        return (
          this.classList.remove(this.classes.scrollUp, this.classes.stuck),
          void (
            this.transparentHeader &&
            this.innerWidth > 1279 &&
            this.domNodes.headerWrapper &&
            this.domNodes.headerWrapper.classList.add("transparent-on-top")
          )
        );
      this.classList.add(this.classes.stuck),
        e > this.headerHeight + s &&
        e > t &&
        !this.classList.contains(this.classes.scrollDown)
          ? (this.classList.remove(this.classes.scrollUp),
            this.classList.add(this.classes.scrollDown))
          : e < t &&
            this.classList.contains(this.classes.scrollDown) &&
            (this.classList.remove(this.classes.scrollDown),
            this.classList.add(this.classes.scrollUp),
            this.transparentHeader &&
              this.innerWidth > 1279 &&
              this.domNodes.headerWrapper &&
              this.domNodes.headerWrapper.classList.remove(
                "transparent-on-top"
              )),
        (t = e);
    });
  }
}
customElements.define("m-header", MHeader);

// Set header height
var _mh = document.querySelector("header.m-header__mobile");
var _dh = document.querySelector("header.m-header__desktop");

function _shh() {
  if (!_mh || !_dh) {
    _mh = document.querySelector("header.m-header__mobile");
    _dh = document.querySelector("header.m-header__desktop");
  }
  // Header
  var _hd = window.innerWidth < 1024 ? _mh : _dh;
  if (_hd) {
    document.documentElement.style.setProperty(
      "--m-header-height",
      _hd.offsetHeight + "px"
    );
    window.MinimogSettings.headerHeight = _hd.offsetHeight;
  }
}
// setTopbarHeight
function _stbh() {
  // Topbar
  var _tb = document.querySelector(".m-topbar");
  if (_tb) {
    document.documentElement.style.setProperty(
      "--m-topbar-height",
      _tb.offsetHeight + "px"
    );
    window.MinimogSettings.topbarHeight = _tb.offsetHeight;
  }
}
// Calc all height
function _calcHeights() {
  _stbh();
  _shh();
}
_calcHeights();
document.addEventListener("matchTablet", () => {
  _calcHeights();
});
document.addEventListener("unmatchTablet", () => {
  _calcHeights();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    const header = document.querySelector("m-header");
    if (typeof Megamenu !== "undefined" && header) {
      const megaMenu = new Megamenu(header);
    }
  });
}
